/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_DescriptionInputs */

const en_visa_o1_description = /** @type {(inputs: Visa_O1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The O-1 category is for individuals whose record of work, recognition, and impact may satisfy the high evidentiary standard for extraordinary ability or achievement in qualifying fields.`)
};

const pt_visa_o1_description = /** @type {(inputs: Visa_O1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria O-1 é para indivíduos cujo registro de trabalho, reconhecimento e impacto possa satisfazer o alto padrão probatório para habilidade ou realização extraordinária em campos qualificados.`)
};

const es_visa_o1_description = /** @type {(inputs: Visa_O1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría O-1 es para personas cuyo historial de trabajo, reconocimiento e impacto pueda satisfacer el alto estándar probatorio de habilidad o logro extraordinario en campos calificados.`)
};

/**
* | output |
* | --- |
* | "The O-1 category is for individuals whose record of work, recognition, and impact may satisfy the high evidentiary standard for extraordinary ability or achi..." |
*
* @param {Visa_O1_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_description = /** @type {((inputs?: Visa_O1_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_description(inputs)
	if (locale === "es") return es_visa_o1_description(inputs)
	return en_visa_o1_description(inputs)
});